import { BaseResponseDto, GetTimezoneFilter, TimezoneListDto } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { TimezoneResponse } from "../../interfaces/timezoneResponse.interface";

export const timezoneActions = createActionGroup({
    source: 'Timezone',
    events: {
        ['[Timezone - API] Load timezone']: props<{ payload?: GetTimezoneFilter }>(),
        ['[Timezone - API] Load success']: props<TimezoneResponse>(),
        ['[Timezone - API] Load failed']: props<BaseResponseDto<TimezoneListDto>>(),
        // ['[Timezone - API] Create country']: props<{ payload: 
        // ['[Timezone - API] Timezone created']: props<TimezoneResponse>(),
        // ['[Timezone - API] Timezone created failed']: props<CreateCoun >(),
        // ['[Timezone - API] Update country']: props<{ payload: 
        // ['[Timezone - API] Timezone updated']: props<TimezoneResponse>(),
        // ['[Timezone - API] Timezone updated failed']: emptyProps(),
        // ['[Timezone - API] Delete country']: props<{ payload: 
        [`[Timezone - API] Reset timezone`]: emptyProps()

    }
})